import React from 'react'
import StaffDetail from '../staff_components/staff_detail'

export default function StaffDetailPage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <StaffDetail />
    </div>
  )
}
